<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :url="url"
                      :operate="operate"
                      :searchs="searchs"
                      :form-fields="formFields"
                      :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "DailyInvestment",
        components: {CommonTable},
        data(){
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'name',
                    placeholder: '项目名称',
                    type: 'input',
                }, {
                    name: 'status',
                    placeholder: '状态',
                    type: 'select',
                    selectValue:[{
                        key: 1,
                        value: '可购买'
                    },{
                        key: 0,
                        value: '已关闭'
                    }]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    add: 'dailyInvestment:add',
                    update: 'dailyInvestment:update',
                    delete: 'dailyInvestment:delete',
                    deleteBatch: 'dailyInvestment:deleteBatch'
                },
                url: {
                    get: '/dailyInvestment/listByCondition',
                    add: '/dailyInvestment/add',
                    update: '/dailyInvestment/update',
                    delete: '/dailyInvestment/delete/',
                    delete_batch: '/dailyInvestment/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'img',
                    label: '图片',
                    detail: true,
                    show: true,
                    img: true,
                    width: '',
                }, {
                    field: 'name',
                    label: '项目名称',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'minAmount',
                    label: '最小投资金额',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'maxAmount',
                    label: '最大投资金额',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'cycle',
                    label: '周期(天)',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'ratio',
                    label: '日收益比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    detail: true,
                    width: '',
                }, {
                    field: 'number',
                    label: '购买次数',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'status',
                        url: '/dailyInvestment/status/update'
                    },
                    values: [{
                        type: 'warning',
                        key: 1,
                        value: '可购买'
                    }, {
                        type: 'danger',
                        key: 0,
                        value: '已关闭'
                    }],
                    width: '80px',
                    confirm: 'name',
                    permission: 'dailyInvestment:update'
                }, {
                    field: 'sort',
                    label: '序号',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'description',
                    label: '规则描述',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    detail: true,
                    width: '',
                }],
                operate: [{
                    icon: 'el-icon-upload2',
                    type: 'text',
                    text: '上传图片',
                    uploadImg: true,
                    url: this.reUrl + '/system/upload/oss/img',
                    // 用于存储handle的row
                    value: {},
                    handle: (row) => {
                        this.value = row;
                    },
                    success: (res) => {
                        if (res.code === 0) {
                            const value = JSON.parse(JSON.stringify(this.value));
                            value.img = res.data;
                            this.$axios.post({
                                url: '/dailyInvestment/img/update',
                                data: value,
                                success: (data) => {
                                    if (data.code === 0){
                                        this.$message.success("图片上传成功");
                                        this.$set(this.value, 'img', value.img);
                                    }else {
                                        this.$message.error(data.msg ? data.msg: "图片上传失败");
                                    }
                                }
                            });
                        } else if (res.code === 102) {
                            window.localStorage.removeItem('username');
                            window.localStorage.removeItem('sessionId');
                            window.parent.location.href = this.feUrl + '/login.html';
                        }
                    }
                }],
                formFields: {
                    addTitle: '添加固定收益',
                    updateTitle: '修改固定收益',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                        filterable: true
                    }, {
                        field: 'name',
                        label: '项目名称',
                        type: 'input',
                        placeholder: '项目名称',
                        rules:[{message: '请输入项目名称', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'minAmount',
                        label: '最小金额',
                        type: 'input',
                        placeholder: '最小金额(USDT)',
                        rules:[{
                            message: '请输入最小金额', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'maxAmount',
                        label: '最大金额',
                        type: 'input',
                        placeholder: '最大金额(USDT)',
                        rules:[{
                            message: '请输入最大金额', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'cycle',
                        label: '周期',
                        type: 'input',
                        placeholder: '周期',
                        rules:[{
                            message: '请输入周期', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'ratio',
                        label: '收益比例',
                        type: 'money',
                        placeholder: '收益比例(%)',
                        rules:[{
                            message: '请输入收益比例(%)', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'number',
                        label: '购买次数',
                        type: 'input',
                        placeholder: '购买次数',
                        rules:[{
                            message: '请输入购买次数', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'status',
                        label: '状态',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '开启购买通道',
                        }, {
                            id: 0,
                            name: '关闭购买通道',
                        }],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: false,
                    }, {
                        field: 'sort',
                        label: '序号',
                        type: 'input',
                        placeholder: '序号',
                        rules:[{
                            message: '请输入序号', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'description',
                        label: '规则描述',
                        type: 'textarea',
                        placeholder: '规则描述',
                        rules:[{
                            message: '请输入规则描述', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                    }],
                }
            }
        },
        methods: {
            setValue(row, v1, v2) {
                if (row.status === 0) {
                    return v1;
                } else if(row.status === 1) {
                    return v2
                }
            },
        }
    }
</script>

<style scoped>

</style>
